import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavrootComponent } from './navroot/navroot.component';
import { EducationComponent } from './education/education.component';
import { ExperienceComponent } from './experience/experience.component';
import { SkillsComponent } from './skills/skills.component';
import { MainPageComponent } from './main-page/main-page.component';


const routes: Routes = [
  {path:'welcome', component: NavrootComponent,
  children:[
    {path:'', component: MainPageComponent},
    {path:'education', component: EducationComponent},
    {path:'experience', component: ExperienceComponent},
    {path:'skills', component: SkillsComponent}
  ]},
  {path:'**', redirectTo:'welcome'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
